export default {
  BusinessQuotation: {
    title: '报价单基本信息',
    code: '报价单号',
    quotationType: '报价类型',
    countryCode: '报价国家',
    createdName: '报价人',
    errMsg1: '产品的长宽高重量不能为0，请更改后再进行操作',
    errMsg2: '表格必填字段不能为空，数值相关的填写不能为0，请认真填写！',
    errMsg3: '此操作会重新清空商品信息，请确认！',
    errMsg4: 'SKU不能为空',
    errMsg5: '请选择出运国家',
    errMsg6: '请先创建商品SKU且保存成功后再审核',
    errMsg7: '请选择状态为“已完成”的数据',
    errMsg8: '托盘数量与此订单的体积不匹配。',
    time: '报价时间范围',
    estima: '利润率范围',
    abandonQuotation: '废弃报价单',
    convertToPO: '转采购单',
    creationDate: '报价时间',
    status: '报价单状态',
    sapSkuBtn: '手动同步SAP-SKU',
    sapSkuData: '同步日期',
    hintMsg: '请选择同步日期',
    saveDraft: '保存为草稿',

    table: {
      select: '选择',
      countryCode: '国家',
      temporaryCode: '临时SKU',
      planQty: '建议订货数量',
      exchangeRate: '汇率',
      cnPurchasePrice: '人民币采购价',
      foreignPurchasePrice: '外币采购价',
      price: '预计售价',
      refundResendPrice: '售后金额',
      totalVolume: '总体积',
      consumptionTaxName: '澳洲/英国商品服务税',
      actualConsumptionTax: '消费税',
      importTariffs: '进口关税',
      importTariffsPercentage: '进口关税百分比',
      ebayPaypalPrice: '平台费',
      laborPrice: '人工费',
      expressPrice: '总快递费',
      postageSurcharge: '快递附加费',
      courier: '快递公司',
      seaInlandFreight: '海运费',
      storagePrice: '仓储费',
      surcharge: '旺季附加费',
      brandName: '品牌名称',
      estimatedProfit: '预计利润',
      estimatedProfitRate: '利润率',
      powerSupplyMode: '供电方式',
      linkUrl: '参考产品链接',
      skuImg: '图片',
      categoryName: '产品分类',
      length: '产品长度',
      width: '产品宽度',
      height: '产品高度',
      weight: '产品重量',
      volume: '产品体积',
      singleMultiComponentProduct: '产品是否由多部件组成',
      qty: '每箱产品数量',
      cartonLength: '外箱长度',
      cartonWidth: '外箱宽度',
      cartonHeight: '外箱高度',
      cartonWeight: '外箱重量',
      cartonVolume: '外箱体积',
      specification: '产品参数',
      differentiatedSellingPoints: '差异化卖点',
      brandTooltip: '新品必填',
      importTariffsTooltip: '英国商品进口关税必填',
      create: '创建SKU'
    }

  }
};
